/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Icelandic
export default {
  'fabric.editor.mediaAddLink': 'Bæta við tengli',
  'fabric.editor.openLink': 'Opna tengil í nýjum flipa',
  'fabric.editor.unlink': 'Fjarlægja tengil',
  'fabric.editor.editLink': 'Breyta tengli',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Líma tengil eða leita í „nýlega skoðað”',
  'fabric.editor.linkPlaceholder': 'Líma tengil',
  'fabric.editor.linkAddress': 'Tengja slóð',
  'fabric.editor.layoutFixedWidth': 'Til baka í staður',
  'fabric.editor.layoutWide': 'Breikka',
  'fabric.editor.layoutFullWidth': 'Fara til fullri breidd',
  'fabric.editor.alignImageRight': 'Samræma rétt',
  'fabric.editor.alignImageCenter': 'Samræma miðju',
  'fabric.editor.alignImageLeft': 'Samræma vinstri',
  'fabric.editor.remove': 'Fjarlægja',
  'fabric.editor.visit': 'Opna tengil í nýjum glugga',
  'fabric.editor.editMode.inviteToEditButton.title': 'Boð til breyta',
  'fabric.editor.saveButton': 'Vista',
  'fabric.editor.cancelButton': 'Hætta við',
  'fabric.editor.alignment': 'Stilling',
  'fabric.editor.normal': 'Eðlilegur texti',
  'fabric.editor.heading1': 'Fyrirsögn 1',
  'fabric.editor.heading1Description': 'Notaðu þetta fyrir efsta stigs fyrirsögn',
  'fabric.editor.heading2': 'Fyrirsögn 2',
  'fabric.editor.heading2Description': 'Notaðu þetta fyrir aðalhluta',
  'fabric.editor.heading3': 'Fyrirsögn 3',
  'fabric.editor.heading3Description': 'Notaðu þetta fyrir undirhluta og hópfyrirsagnir',
  'fabric.editor.heading4': 'Fyrirsögn 4',
  'fabric.editor.heading4Description': 'Notaðu þetta fyrir neðstu fyrirsagnirnar',
  'fabric.editor.heading5': 'Fyrirsögn 5',
  'fabric.editor.heading5Description': 'Notaðu þetta til að hópa saman listaatriði',
  'fabric.editor.heading6': 'Fyrirsögn 6',
  'fabric.editor.heading6Description': 'Notaðu þetta fyrir lægra stigs fyrirsagnir',
  'fabric.editor.blockquote': 'Vitna',
  'fabric.editor.blockquote.description': 'Setja inn tilboð eða tilvitnun',
  'fabric.editor.codeblock': 'Brot úr kóða',
  'fabric.editor.codeblock.description': 'Birtu kóða með auðkenndri málskipan',
  'fabric.editor.infoPanel': 'Upplýsingar pallborð',
  'fabric.editor.infoPanel.description': 'Auðkenndu upplýsingar á lituðum skjá',
  'fabric.editor.notePanel': 'Athugaðu spjaldið',
  'fabric.editor.notePanel.description': 'Bættu við athugasemd á lituðum skjá',
  'fabric.editor.successPanel': 'Velgengni spjaldið',
  'fabric.editor.successPanel.description': 'Bættu ráðleggingum við á lituðum skjá',
  'fabric.editor.warningPanel': 'Viðvörunar spjaldið',
  'fabric.editor.warningPanel.description': 'Bættu við viðvörunarathugasemd á lituðum skjá',
  'fabric.editor.errorPanel': 'Villa spjaldið',
  'fabric.editor.errorPanel.description': 'Gerðu villur áberandi á lituðum skjá',
  'fabric.editor.other': 'Aðrir...',
  'fabric.editor.textStyles': 'Texta stíl',
  'fabric.editor.displayBlock': 'Sýna sem kort',
  'fabric.editor.displayInline': 'Sýna sem hlekkur',
  'fabric.editor.displayLink': 'Birta sem texta',
  'fabric.editor.selectLanguage': 'Velja tungumál',
  'fabric.editor.edit': 'Breyta',
  'fabric.editor.editorHelp': 'Ritstjórahjálp',
  'fabric.editor.helpDialogTips': 'Styðjið á {keyMap} til að opna þetta samtal á skjótan hátt hvenær sem er',
  'fabric.editor.keyboardShortcuts': 'Flýtilyklar',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.undo': 'Afturkalla',
  'fabric.editor.redo': 'Endurgera',
  'fabric.editor.pastePlainText': 'Líma ódulritaðan texta',
  'fabric.editor.altText': 'Baktexti',
  'fabric.editor.closeHelpDialog': 'Loka hjálparsamtali',
  'fabric.editor.quickInsert': 'Fýtiinnsetning',
  'fabric.editor.displayText': 'Texti sem á að birta',
  'fabric.editor.clearLinkText': 'Hreinsa texta',
  'fabric.editor.clearLink': 'Hreinsa tengli',
  'fabric.editor.action': 'Aðgerð atriði',
  'fabric.editor.action.description': 'Búa til og nota aðgerðartákn',
  'fabric.editor.link': 'Tengja',
  'fabric.editor.link.description': 'Setja inn tengil',
  'fabric.editor.filesAndImages': 'Skrár & myndir',
  'fabric.editor.filesAndImages.description': 'Bæta myndum og aðrar skrár á síðunni þinni',
  'fabric.editor.image': 'Mynd',
  'fabric.editor.mention': 'Nefna',
  'fabric.editor.mention.description': 'Nefndu einhvern til að senda þeim tilkynningu',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': 'Notaðu lyndistákn til að tjá hugmyndir 🎉 og tilfinningar 😄',
  'fabric.editor.table': 'Tafla',
  'fabric.editor.table.description': 'Setja inn töflu',
  'fabric.editor.decision': 'Ákvörðun',
  'fabric.editor.decision.description': 'Fangaðu ákvarðanir svo auðvelt sé að fylgjast með þeim',
  'fabric.editor.feedbackDialog': 'Gefa álit',
  'fabric.editor.feedbackDialog.description': 'Segðu okkur frá reynslu þinni Að nota nýja ritstjórann',
  'fabric.editor.horizontalRule': 'Divider',
  'fabric.editor.horizontalRule.description': 'Aðskildu innihald með láréttri stiku',
  'fabric.editor.date': 'Dagsetning',
  'fabric.editor.date.description': 'Bættu við dagsetningu með dagatali',
  'fabric.editor.placeholderText': 'Placeholder texti',
  'fabric.editor.columns': 'Útlit',
  'fabric.editor.columns.description': 'Byggðu upp síðuna þína með því að nota hluta',
  'fabric.editor.status': 'Staða',
  'fabric.editor.status.description': 'Bæta við sérsniðnu stöðumerki',
  'fabric.editor.viewMore': 'Skoða fleiri',
  'fabric.editor.insertMenu': 'Setja inn',
  'fabric.editor.twoColumns': 'Tveir dálkar',
  'fabric.editor.threeColumns': 'Þrír dálkar',
  'fabric.editor.rightSidebar': 'Hægri hliðarstika',
  'fabric.editor.leftSidebar': 'Vinstri hliðarstika',
  'fabric.editor.threeColumnsWithSidebars': 'Þrír dálkar með hliðarstikum',
  'fabric.editor.unorderedList': 'Bullet listi',
  'fabric.editor.unorderedList.description': 'Búa til óraðaðan lista',
  'fabric.editor.orderedList': 'Númeraður listi',
  'fabric.editor.orderedList.description': 'Búa til pöntuðum lista',
  'fabric.editor.lists': 'Lists',
  'fabric.editor.annotate': 'Skrifa skýringar',
  'fabric.editor.wrapLeft': 'Vinstriskrið',
  'fabric.editor.wrapRight': 'Hægriskrið',
  'fabric.editor.backLink': 'Til baka',
  'fabric.editor.info': 'Upplýsingar',
  'fabric.editor.note': 'Athugasemd',
  'fabric.editor.success': 'Tókst',
  'fabric.editor.warning': 'Viðvörun',
  'fabric.editor.error': 'Villa',
  'fabric.editor.placeholderTextPlaceholder': 'Bæta inn staðgengilstexta',
  'fabric.editor.statusPlaceholder': 'Stilla stöðu',
  'fabric.editor.tableOptions': 'Valmöguleikar fyrir töflu',
  'fabric.editor.headerRow': 'Hausröð',
  'fabric.editor.headerColumn': 'Hausdálkur',
  'fabric.editor.numberedColumn': 'Númeraður dálkur',
  'fabric.editor.cellBackground': 'Bakgrunnur reits',
  'fabric.editor.mergeCells': 'Sameina reiti',
  'fabric.editor.splitCell': 'Skipta reit upp',
  'fabric.editor.clearCells': '{0, plural, one{Hreinsa reit} other{Hreinsa reiti}}',
  'fabric.editor.sortColumnASC': 'Sort column A → Z',
  'fabric.editor.sortColumnDESC': 'Sort column Z → A',
  'fabric.editor.canNotSortTable': "⚠️ You can't sort a table with merged cells",
  'fabric.editor.insertColumn': 'Setja dálk inn',
  'fabric.editor.removeColumns': '{0, plural, one{Fjarlægja dálk} other{Fjarlægja dálka}}',
  'fabric.editor.insertRow': 'Setja röð inn',
  'fabric.editor.removeRows': '{0, plural, one{Fjarlægja röð} other{Fjarlægja raðir}}',
  'fabric.editor.cellOptions': 'Valmöguleikar fyrir reit',
  'fabric.editor.decisionPlaceholder': 'Bæta við ákvörðun...',
  'fabric.editor.taskPlaceholder': "Sláðu inn aðgerðina þína, notaðu '@' til að úthluta einhverjum.",
  'fabric.editor.textColor': 'Textalitur',
  'fabric.editor.underline': 'Undirstrika',
  'fabric.editor.strike': 'Gegnumstrikun',
  'fabric.editor.code': 'Kóði',
  'fabric.editor.subscript': 'Niðurskrifað',
  'fabric.editor.superscript': 'Superscript',
  'fabric.editor.clearFormatting': 'Hreinsa forsnið',
  'fabric.editor.moreFormatting': 'Meira formatting',
  'fabric.editor.bold': 'Djörf',
  'fabric.editor.italic': 'Skáletrað',
  'fabric.editor.selected': 'Valinn'
};